import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  formContainer: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  addButton: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  dpoCard: {
    marginBottom: theme.spacing(3),
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.spacing(1),
  },
  deleteButton: {
    marginLeft: 'auto',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: 'rgba(244, 67, 54, 0.08)',
      color: '#f44336',
    },
  },
  gridContainer: {
    padding: theme.spacing(2),
  },
}))

export default useStyles
